import { INTENT_HREF } from '../components/cta';
import { ARROW_ICON } from '../components/icons';
import { eyebrow, mesh } from '../components/primitives';
import { ctaBand } from '../components/sections';

/* ---- Capacity calculator (/calculator) ---- */
export function pageCalculator(): string {
  const field = (id: string, label: string, hint: string, attrs: string, val: number, suffix = ''): string => `
    <div class="field calc-field"><label for="${id}">${label}</label>
      <div class="calc-in"><input class="input" id="${id}" type="number" inputmode="decimal" value="${val}" ${attrs} aria-describedby="${id}-hint">${suffix ? `<span class="calc-suf">${suffix}</span>` : ''}</div>
      <span class="hint" id="${id}-hint">${hint}</span></div>`;
  return `
  <section class="hero compact" aria-labelledby="h1">
    ${mesh()}
    <div class="wrap rv">
      ${eyebrow('Capacity calculator')}
      <h1 id="h1">Estimate the capacity <span class="grad">your team could get back.</span></h1>
      <p class="lede" style="margin-top:24px">Enter your own numbers to estimate how much professional time better infrastructure could return each year. Everything is calculated from what you enter.</p>
    </div>
  </section>
  <section class="s" style="padding-top:48px" aria-label="Calculator">
    <div class="wrap calc">
      <form class="form-card calc-inputs" id="calc" novalidate>
        <h2 class="h-card">Your team</h2>
        ${field('c-team', 'People working on property tax workflows', 'Consultants, analysts, paralegals and support staff.', 'min="1" max="10000" step="1"', 25)}
        <div class="field calc-field"><label for="c-min">Minutes returned per person, per day</label>
          <div class="calc-range"><input id="c-min" type="range" min="0" max="120" step="5" value="30" aria-describedby="c-min-hint c-min-out"><output id="c-min-out" for="c-min">30 min</output></div>
          <span class="hint" id="c-min-hint">Use your own estimate. For reference, ReTax360 has observed approximately 30–60 minutes of daily time savings per team member in an enterprise deployment.</span></div>
        ${field('c-days', 'Working days per year', 'Typically 230–250.', 'min="1" max="366" step="1"', 240)}
        ${field('c-cost', 'Fully loaded cost per hour', 'Salary, benefits and overhead per working hour. Use your own figure.', 'min="0" max="10000" step="1"', 75, 'USD')}
      </form>
      <div class="calc-out" aria-live="polite">
        <div class="calc-card">
          <p class="colh">Estimated time returned</p>
          <div class="calc-big" id="r-hours">–</div><p class="calc-unit">hours per year</p>
          <div class="calc-row">
            <div><b id="r-fte">–</b><span>full-time equivalents of capacity</span></div>
            <div><b id="r-pp">–</b><span>hours per person, per year</span></div>
            <div><b id="r-value">–</b><span>value of time returned</span></div>
          </div>
          <p class="calc-note">Estimates only, based entirely on your inputs; not a guarantee of results. Full-time equivalent assumes 8-hour working days.</p>
          <a class="btn btn-primary" id="calc-cta" href="${INTENT_HREF['enterprise-contact']}" data-cta="capacity_calculator">Discuss your numbers with our team ${ARROW_ICON}</a>
        </div>
      </div>
    </div>
  </section>
  ${ctaBand()}`;
}
